import { render } from "./HabitsConfig.vue?vue&type=template&id=2b8ce8b9"
import script from "./HabitsConfig.vue?vue&type=script&lang=js"
export * from "./HabitsConfig.vue?vue&type=script&lang=js"

import "./HabitsConfig.vue?vue&type=style&index=0&id=2b8ce8b9&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__